import React from "react";
import {allFamilies, Family, FamilyDetails, spectra, Wave} from "./spectra";
import {ThumbnailChart} from "./ThumbnailChart";

function oneRow(name: Family, waves: Wave[], offset = 0) {
    return <>
        {
            waves.map((w: Wave, i: number) => <td>
                <a href={`/${name}/${i + offset + 1}`}>
                    <ThumbnailChart harmonics={w.harmonics}/>
                </a>
            </td>)
        }
    </>;
}

export function GridRowForFamily({name, family}: {name: Family, family: FamilyDetails}) {
    const firstRowMembers = family.members.slice(0, 12);
    const secondRowMembers = family.members.slice(12);
    if (secondRowMembers.length === 0) {
        return (
            <tr>
                <th><a href={`/${name}`}>{name}</a></th>
                {oneRow(name, firstRowMembers)}
            </tr>);
    }
    return (<>
        <tr>
            <th rowSpan={2}><a href={`/${name}`}>{name}</a></th>
            {oneRow(name, firstRowMembers)}
        </tr>
        <tr>
            {oneRow(name, secondRowMembers, 12)}
        </tr>
    </>);
}

export function FrontPage() {
    return (<>
        <article>
            <h1>Hydrasynth wavetable explorer</h1>
            <p>Hydrasynth is a digital wavetable-based synthesizer, with powerful FM and wave morphing capabilities.
                It boasts 219 basic waveforms. When you choose waves on the front panel, you can see all the shapes on
                its screen, but that's not enough to choose.
                If you're using one of the modulation options it offers, you probably want to know the harmonic content
                of the waveforms you're operating on, and there's no way to see that on-device.</p>
            <p>This website has the spectra of all 219 waveforms so you can see each one. You can compare waveforms,
                choose a waveform for a particular sound you want to make, or just browse through the list to better
                understand your instrument.</p>
            <p>You can click on one of the spectra below to see it in more detail, or click the name of a family to see that whole family.</p>
        </article>

        <table className="thumbnailGrid">
            { allFamilies.map(f => <GridRowForFamily name={f} family={spectra[f]} />) }
        </table>
    </>);
}